import { z } from 'zod/v4'

export const subdomainSchema = z.object({
  errorMessage: z.string().optional(),
  migrationFrom: z.string().optional(),
  domain_connect: z.boolean().optional(),
  error: z.string().optional(),
  error_description: z.string().optional(),
})

export type SubdomainSearch = z.infer<typeof subdomainSchema>
